export const PREFIX_MOBILE_URL = "/mobile-view";
